import classNames from 'classnames'
import PropTypes from 'prop-types'

import styles from './Accordion.module.css'

export const ListItem = ({
  children,
  selected,
  onClick,
  noTranslate,
  disabled,
  className,
  testId,
}) => (
  <div
    className={classNames(styles.accordionListItem, className, {
      [styles.accordionListItem__selected]: selected && !disabled,
      [styles.accordionListItem__unselected]: !selected && !disabled,
      [styles.accordionListItem__disabled]: disabled,
      notranslate: noTranslate,
    })}
    onClick={!disabled ? onClick : null}
    role="button"
    tabIndex="0"
    onKeyPress={null}
    data-testid={testId}
  >
    {children}
  </div>
)

ListItem.propTypes = {
  children: PropTypes.node.isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  noTranslate: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  testId: PropTypes.string,
}

ListItem.defaultProps = {
  selected: false,
  onClick: null,
  noTranslate: false,
  disabled: false,
  className: '',
  testId: undefined,
}

export default ListItem
